// @flow
import React from 'react'
import { TextInput } from 'react-native'

import styles from './style'

type Props = {
  style?: Object,
  value?: string,
  placeholder?: string,
  onChange: Function,
}
const Input = ({ style, value, placeholder, onChange }: Props) => {
  return (
    <TextInput
      value={value}
      placeholder={placeholder}
      style={[styles.container, styles.text, style]}
      onChangeText={text => onChange(text)}
    />
  )
}
export default Input
